import Vue from 'vue';

// 新增$bus全域變數
Vue.prototype.$bus = new Vue();



// WEBPACK FOOTER //
// ./src/bus.js